<h2 mat-dialog-title class="title" [class.offer]="offered">{{ vm.title }}</h2>

<mat-dialog-content class="content" [class.wide]="layout.wide" [style.--n]="layout.cols">
  @if (!vm.asOf) {
    <div class="loading"><mat-spinner diameter="20" aria-label="Chargement"></mat-spinner> Chargement du dossier…</div>
  } @else {
    <div class="cols">
      <section class="dlg-row pour">
        <div class="row-head">
          <span class="lbl">Pour</span>
          <button type="button" class="link toggle-all" (click)="toggleAll()">{{ vm.allChecked ? 'Tout décocher' : 'Tout cocher' }}</button>
        </div>
        @for (g of vm.groups; track g.key) {
          <div class="scope-group">
            <label class="grp" [class.dis]="g.disabled">
              <input type="checkbox" [checked]="g.all" [indeterminate]="g.some && !g.all" [disabled]="g.disabled" (change)="toggleGroup(g)" />
              <span>{{ g.label }}</span>
            </label>
            <div class="scope-list">
              @for (l of g.lines; track l.id) {
                <label [class.dis]="l.disabled" [attr.title]="l.title">
                  <input type="checkbox" [attr.data-line]="l.id" [checked]="l.checked" [disabled]="l.disabled" (change)="toggleLine(l.id)" />
                  <span class="ln"><span class="nm">{{ l.name }}</span><small>{{ l.sub }}</small></span>
                </label>
              }
            </div>
          </div>
        }
        <span class="hint">Une décision est enregistrée par matériel coché.</span>
      </section>

      <div class="edit-zone">
        <section class="dlg-row">
          <span class="lbl">Motif @if (!reasonId) {<span class="req">à choisir</span>}</span>
          @if (vm.reasonsNote) {
            <span class="hint">{{ vm.reasonsNote }}</span>
          }
          <div class="chips reasons">
            @for (r of vm.reasons; track r.id) {
              <button type="button" class="chip" [attr.data-reason]="r.id" [attr.aria-pressed]="r.pressed" (click)="pickReason(r.id)">
                <span class="rdot" [style.background]="r.color"></span>{{ r.name }}
              </button>
            }
          </div>
          <input type="text" class="comment" [value]="comment" [placeholder]="vm.commentHint" [attr.aria-label]="vm.commentHint" (input)="onComment($any($event.target).value)" />
        </section>

        @if (isEdit) {
          <section class="dlg-row">
            <label class="lbl" for="rg-edit-reason">Motif de la modification</label>
            <input #editReasonInput id="rg-edit-reason" type="text" class="comment edit-reason" [value]="editReason" placeholder="Obligatoire : pourquoi cette modification" (input)="onEditReason($any($event.target).value)" />
          </section>
        }

        <div class="fields">
          <div class="field" [class.active]="phase === 'start'">
            <label for="rg-start">{{ offered ? 'Offert à partir du' : 'Interruption à partir du' }}</label>
            <input #startInput id="rg-start" type="text" autocomplete="off" placeholder="JJ/MM/AAAA" [value]="vm.startText"
              (focus)="onFieldFocus('start')" (input)="startInput.setCustomValidity('')" (change)="onTyped('start', startInput)" />
          </div>
          <div class="field" [class.active]="phase === 'end'">
            <label for="rg-end">{{ offered ? 'Dernier jour offert (inclus)' : 'Dernier jour interrompu (inclus, facultatif)' }}</label>
            <input #endInput id="rg-end" type="text" autocomplete="off" placeholder="Inconnu = interruption ouverte" [value]="vm.endText"
              (focus)="onFieldFocus('end')" (input)="endInput.setCustomValidity('')" (change)="onTyped('end', endInput)" />
          </div>
        </div>

        <div class="chips quick" aria-label="Raccourcis">
          <button type="button" class="chip" data-q="today" (click)="quick('today')">Aujourd'hui</button>
          <button type="button" class="chip" data-q="yesterday" (click)="quick('yesterday')">Hier</button>
          <button type="button" class="chip" data-q="delivery" [attr.aria-pressed]="start === null" (click)="quick('delivery')">Dès la livraison</button>
          <span class="gap"></span>
          <button type="button" class="chip" data-q="unknown" [disabled]="start === undefined" [attr.aria-pressed]="start !== undefined && end === null && phase === 'start'" (click)="quick('unknown')">Reprise inconnue</button>
          <button type="button" class="chip" data-q="3" [disabled]="start === undefined" (click)="quick(3)">+3 j</button>
          <button type="button" class="chip" data-q="7" [disabled]="start === undefined" (click)="quick(7)">+7 j</button>
          <button type="button" class="chip" data-q="14" [disabled]="start === undefined" (click)="quick(14)">+14 j</button>
          <button type="button" class="chip" data-q="month" [disabled]="start === undefined" (click)="quick('month')">+1 mois</button>
        </div>

        <div class="pick" #pickBox>
          <app-rental-day-picker mode="range" [start]="start ?? null" [end]="end" [startFloor]="start === null ? vm.floor : null"
            [leftMonth]="leftMonth" [monthCount]="months" [today]="vm.asOf" [marks]="vm.marks" [tone]="offered ? 'violet' : 'amber'" [phase]="phase"
            (phaseChange)="onPhase($event)" (startChange)="onPickStart($event)" (endChange)="onPickEnd($event)" (leftMonthChange)="onLeftMonth($event)"
            (escape)="close()"></app-rental-day-picker>
        </div>
      </div>
    </div>
  }
</mat-dialog-content>

@if (vm.overlap; as ov) {
  <div class="overlap">
    <span>{{ ov.text }}</span>
    @if (ov.canExtend) {
      <button type="button" class="chip extend" (click)="extend(ov)">Prolonger celle-ci</button>
    }
  </div>
}
<app-rental-effect class="eff" [state]="sim" [rangeText]="vm.rangeText" [scope]="vm.scope" [warnings]="vm.warnings" [errors]="vm.errors"
  [focusLineIds]="vm.checkedIds" [store]="store"></app-rental-effect>

<mat-dialog-actions class="actions">
  @if (vm.resumeToday === 'show') {
    <button mat-stroked-button type="button" class="resume-today" [disabled]="saving" (click)="resumeToday()">Reprise aujourd'hui</button>
  } @else if (vm.resumeToday === 'started-today') {
    <span class="not-started started-today" title="Le dernier jour interrompu ne peut précéder le début : une interruption commencée aujourd'hui s'annule.">Commencée aujourd'hui : l'annuler</span>
  } @else if (vm.resumeToday === 'not-started') {
    <span class="not-started">Interruption pas encore commencée</span>
  }
  @if (isEdit) {
    <button mat-stroked-button type="button" class="danger cancel-decision" [disabled]="saving" (click)="cancelDecision()">{{ offered ? 'Annuler le geste' : "Annuler l'interruption" }}</button>
  }
  <span class="spacer"></span>
  <button mat-stroked-button type="button" class="close" [disabled]="saving" (click)="close()">Fermer</button>
  <button mat-flat-button color="primary" type="button" class="save" [disabled]="!vm.canSave || saving" (click)="save()">
    @if (saving) {
      <mat-spinner diameter="16" class="btn-spin"></mat-spinner>
    }
    Enregistrer
  </button>
</mat-dialog-actions>
